import api from './api';

export const progressService = {
  // Get all months
  async getMonths() {
    const response = await api.get('/activities/months');
    return response.data;
  },

  // Get month with all weeks and activities
  async getMonthWithWeeks(monthNumber) {
    const response = await api.get(`/activities/months/${monthNumber}`);
    return response.data;
  },

  // Get week details with activities
  async getWeek(weekNumber) {
    const response = await api.get(`/activities/weeks/${weekNumber}`);
    return response.data;
  },

  // Get activity details
  async getActivity(activityId) {
    const response = await api.get(`/activities/activity/${activityId}`);
    return response.data;
  },

  // Get curriculum overview
  async getCurriculum() {
    const response = await api.get('/activities/curriculum');
    return response.data;
  },

  // Get game map (all months with weeks and env days)
  async getGameMap() {
    const response = await api.get('/activities/game-map');
    return response.data;
  },

  // Student: Mark activity as complete
  async completeActivity(activityId, data = {}) {
    const response = await api.post('/progress/me/complete-activity', {
      activity_id: activityId,
      notes: data.notes,
      photo_url: data.photoUrl,
    });
    return response.data;
  },

  // Student: Mark environmental day as complete
  async completeEnvironmentalDay(envDayId) {
    const response = await api.post('/progress/me/complete-env-day', {
      env_day_id: envDayId,
    });
    return response.data;
  },

  // Student: Get current week progress with activities
  async getCurrentWeekProgress() {
    const response = await api.get('/progress/me/current-week');
    return response.data;
  },

  // Student: Get all weeks progress
  async getAllWeeksProgress() {
    const response = await api.get('/progress/me/weeks');
    return response.data;
  },
};

export default progressService;
